import type { HeaderModel, FooterModel, SiteSettingsModel, Link } from '@site/shared'
import { mapMedia } from './media'

const str = (v: unknown) => (typeof v === 'string' && v.trim() ? v : undefined)

function mapLinks(raw: unknown): Link[] {
  const items = Array.isArray(raw) ? (raw as Array<Record<string, unknown>>) : []
  return items.flatMap((l) => {
    const label = str(l.label)
    const href = str(l.href)
    return label && href ? [{ label, href }] : []
  })
}

export function mapHeader(raw: Record<string, unknown>): HeaderModel {
  return { nav: mapLinks(raw.nav), ctaLabel: str(raw.ctaLabel), ctaHref: str(raw.ctaHref) }
}

export function mapFooter(raw: Record<string, unknown>): FooterModel {
  return { tagline: str(raw.tagline), links: mapLinks(raw.links) }
}

export function mapSiteSettings(raw: Record<string, unknown>, baseUrl: string): SiteSettingsModel {
  const contactRaw = (raw.contact as Record<string, unknown> | undefined) ?? {}
  return {
    contact: {
      email: str(contactRaw.email),
      phone: str(contactRaw.phone),
      address: str(contactRaw.address),
    },
    defaultSeoTitle: str(raw.defaultSeoTitle),
    defaultSeoDescription: str(raw.defaultSeoDescription),
    defaultOgImageUrl: mapMedia(raw.defaultOgImage as Record<string, unknown>, baseUrl)?.url,
  }
}
